import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const OAuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleOAuthCallback = async () => {
      try {
        // Check URL parameters for errors
        const params = new URLSearchParams(location.search);
        const errorParam = params.get('error');
        
        if (errorParam) {
          console.error('OAuth error:', errorParam);
          setError(errorParam);
          // Redirect to login with error message after a delay
          setTimeout(() => {
            navigate('/login', { 
              replace: true,
              state: { message: 'Authentication failed. Please try again.' }
            });
          }, 2000);
          return;
        }

        // Check if we're in a popup window
        if (window.opener && !window.opener.closed) {
          // We're in a popup - notify parent and close
          try {
            window.opener.postMessage({ 
              type: 'OAUTH_SUCCESS',
              timestamp: Date.now()
            }, window.location.origin);
            
            // Give a moment for the message to be sent
            setTimeout(() => {
              window.close();
            }, 100);
            
            // If window.close() doesn't work (blocked by browser), redirect
            setTimeout(() => {
              if (!window.closed) {
                window.location.href = '/';
              }
            }, 1000);
          } catch (error) {
            console.error('Error communicating with parent window:', error);
            // Fallback: redirect to home
            window.location.href = '/';
          }
        } else {
          // Not in a popup - this is a direct redirect (mobile or popup-blocked scenario)
          // Wait a moment for the session to be established
          setTimeout(() => {
            navigate('/', { replace: true });
          }, 500);
        }
      } catch (error) {
        console.error('OAuth callback error:', error);
        setError(error.message);
        setTimeout(() => {
          navigate('/login', { 
            replace: true,
            state: { message: 'Authentication failed. Please try again.' }
          });
        }, 2000);
      }
    };

    handleOAuthCallback();
  }, [navigate, location]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontFamily: 'Open Sans, sans-serif',
      color: '#666',
      background: '#f9fafb'
    }}>
      <div style={{ textAlign: 'center', padding: '20px' }}>
        {error ? (
          <>
            <div style={{
              fontSize: '48px',
              marginBottom: '16px'
            }}>❌</div>
            <p style={{ color: '#ef4444', fontWeight: 600 }}>Authentication failed</p>
            <p style={{ fontSize: '14px', color: '#6b7280' }}>Redirecting...</p>
          </>
        ) : (
          <>
            <div style={{
              width: '40px',
              height: '40px',
              border: '3px solid #e5e7eb',
              borderTopColor: '#00b14f',
              borderRadius: '50%',
              animation: 'spin 0.8s linear infinite',
              margin: '0 auto 16px'
            }} />
            <p style={{ fontWeight: 600, color: '#1f2937' }}>Completing sign in...</p>
            <p style={{ fontSize: '14px', color: '#6b7280', marginTop: '8px' }}>
              {window.opener && !window.opener.closed 
                ? 'This window will close automatically' 
                : 'Please wait while we redirect you'}
            </p>
          </>
        )}
      </div>
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default OAuthCallback;
